<template>
  <div>
    <kn-form-subtitle title="Agregar sub categoria" />
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row>
        <v-col 
          class="pb-0" 
          cols="12"
          md="4"
          lg="4"
          xl="4"
        >
          <v-subheader>Título:</v-subheader>
        </v-col>
        <v-col class="pb-0">
          <v-text-field
            v-model="expenseSubCategory.dato"
            dense
            outlined
            :rules="[rules.required]"
          />
        </v-col>
      </v-row>
      <kn-form-action-buttons
        class="mb-14"
        :small="true"
        :disableAccept="invalidFields"
        @accept="save"
        @cancel="clear"
      />
    </v-form>
    <kn-form-subtitle
      title="Listado de sub categorias"
      divider-position="bottom"
    />
    <v-list>
      <v-list-item-group>
        <template v-for="(item, index) in expenseCategoriesActive">
          <v-list-item :key="item.dato">
              <v-list-item-content>
                <v-text-field
                  v-if="toUpdate && item.id === expenseSubCategory.id"
                  class="mb-0 pb-0"
                  v-model="expenseSubCategory.dato"
                  dense
                  outlined
                />
                <v-list-item-title
                  v-else
                  v-text="item.dato"
                />
              </v-list-item-content>

              <v-list-item-action>
                <v-row
                  v-if="toUpdate && item.id === expenseSubCategory.id"
                  no-gutters
                >
                  <v-col>
                    <v-btn
                      icon
                      color=primary
                      @click="clearInline"
                    >
                      <v-icon color="primary">
                        mdi-cancel
                      </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      icon
                      color=primary
                      @click="save"
                    >
                      <v-icon color="primary">
                        mdi-content-save-outline
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row
                  v-else
                  no-gutters
                >
                  <v-col>
                    <v-btn
                      icon
                      color=primary
                      @click="edit(item)"
                    >
                      <v-icon color="primary">
                        mdi-pencil-outline
                      </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      icon
                      color=primary
                      @click="deleteInline(item.id)"
                    >
                      <v-icon color="primary">
                        mdi-trash-can-outline
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item-action>
          </v-list-item>

          <v-divider
            v-if="index < expenseCategoriesActive.length - 1"
            :key="index"
          ></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { api } from '@/api/axios-base'
import { validationFormMixin } from '@/mixins/validationFormMixin'
export default {
  components: {
    KnFormSubtitle: () => import('@/components/KnFormSubtitle.vue'), 
    KnFormActionButtons: () => import('@/components/KnFormActionButtons.vue') 
  },
  mixins: [validationFormMixin],
  data() {
    return {
      errors: [],
      valid: true,
      expenseSubCategory: {
        id: 'NA', // No asignado
        dato: null,
        id_autor: null,
        id_institucion_educativa: null
      },
      expenseCategories: [],
      toUpdate: false
    }
  },
  computed: {
    ...mapState(['institutionId', 'userData']),
    actionTitle() {
      return this.toUpdate ? 'Actualizar' : 'Crear'
    },
    expenseCategoriesActive() {
      return this.expenseCategories.filter(category => category.estatus_sistema === true)
    },
    invalidFields() {
      return this.objectHasNulls(this.expenseSubCategory)
    }
  },
  async created() {
    this.expenseSubCategory.id_autor = this.userData.id
    this.expenseSubCategory.id_institucion_educativa = this.institutionId
    this.expenseCategories = await this.fetchExpenseSubCategoryByEI(this.institutionId)

  },
  methods: {
    async fetchExpenseSubCategoryByEI(institutionId) {
      try {
        const response = await api.get(`/administracion/api/subcategoria-egreso-by-ie/?id_institucion=${institutionId}`)
        const responseData = await response.data
        return responseData
      } catch (error) {
        console.error('Error al intentar obtener sub categorias de egresos por institucion educativa', error);
      }
    },
    async createExpenseSubCategory() {
      try {
        const response = await api.post('/administracion/crear-sub-categoria-egreso', {
          nombre_sub_categoria_egreso: this.expenseSubCategory.dato,
          id_autor: this.expenseSubCategory.id_autor,
          id_institucion_educativa: this.expenseSubCategory.id_institucion_educativa
        })
        const responseData = await response.data
        if (responseData.e) {
          this.errors.push('Ocurrió un error, no se pudo crear la sub categoria.')
        }
      } catch (error) {
        console.error('Error al intentar crear sub categoria de egreso', error)
        this.errors.push('Error al intentar crear sub categoria de egreso')
      }
    },
    async updateExpenseSubCategory() {
      try {
        const response = await api.patch('/administracion/update-sub-categoria-egreso', {
          id: this.expenseSubCategory.id,
          categoria_egreso: this.expenseSubCategory.dato,
          id_institucion_educativa: this.institutionId
        })
        const responseData = await response.data
        if (responseData.e) {
          this.errors.push('Ocurrió un error, no se pudo actualizar la sub categoria')
        }
      } catch (error) {
        console.error('Error al intentar actualizar sub categoria de egreso', error);
      }
    },
    // Los deletes no eliminan los registros, cambian el estatus a False
    async deleteExpenseSubCategory(categoryId) {
      try {
        const response = await api.post('/administracion/delete-sub-categoria-egreso', {
          id_sub_categoria_egreso: categoryId
        })
        const responseData = await response.data
        if (responseData.e) {
          this.errors.push('Ocurrió un error, no se pudo eliminar la sub categoria')
        }
      } catch (error) {
        console.error('Error al intentar eliminar sub categoria de egreso', error);
      }
    },
    async save() {
      if (this.toUpdate) {
        await this.updateExpenseSubCategory()
        this.toUpdate = false
      } else {
        await this.createExpenseSubCategory()
        this.clear()
      }
      this.expenseCategories = await this.fetchExpenseSubCategoryByEI(this.institutionId)
      this.clear()
    },
    clear() {
      this.expenseSubCategory = {
        id: 'NA', // No asignado
        dato: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId 
      }
      this.toUpdate = false
      this.$refs.form.resetValidation()
    },
    clearInline() {
      this.expenseSubCategory = {
        id: 'NA', // No asignado
        dato: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId 
      }
      this.toUpdate = false
      this.$refs.form.resetValidation()
    },
    edit(item) {
      this.expenseSubCategory = {...item}
      // console.log('Item a editar:', this.expenseSubCategory);
      this.toUpdate = true
    },
    async deleteInline(itemId) {
      await this.deleteExpenseSubCategory(itemId)
      this.expenseCategories = await this.fetchExpenseSubCategoryByEI(this.institutionId)
      this.clearInline()
    }
  },
}
</script>

<style>

</style>